<template>
    <StepTemplate :activeStepNr="this.activeStepNr"
                  :myStepNr="this.myStepNr"
                  :value="value"

    >
        <div @click="loadTarife">[RELOAD]</div>


        <div slot="slide-form" v-if="Tarife_loaded == false" class="text-xl-center">
            <v-card-text>
                Tarife werde ermittelt ...
            </v-card-text>
            <v-card-text>
                <div>
                    <v-progress-circular
                            indeterminate
                            v-bind:size="50"
                            class="primary--text"
                    />
                </div>
                <br>
            </v-card-text>
        </div>

        <template slot="slide-form" v-if="Tarife_loaded == true">


            <v-form data-vv-scope="xxx" @click.alt="testFillForm()" class="my_radio_form">
                <!--============================================================================================================-->
                <!--
                <v-layout row>
                    <v-flex xs11 class="mt-2"><h5>{{this.label}}</h5></v-flex>
                </v-layout>
                -->
                <!--============================================================================================================-->
                <v-layout row class="section_header">
                    <v-flex xs11 class="mt-2 blue-grey lighten-4"><h6>Tarife </h6></v-flex>
                </v-layout>

                <!------------------------------------------------------------------------------------------------------------>
                <v-layout row>
                    <v-layout row class="my_radio input-group input-group--text-field input-group--light "
                              :class="{'input-group--error':$v.value.fieldValues.vertrag_tarifwahl.$error, 'input-group--required':$v.value.fieldValues.vertrag_tarifwahl.required}"
                    >
                        <!-- DUMMY , sonst werden die Radios beim Validate nicht rot -->
                    </v-layout>
                </v-layout>
                <v-layout row class="radio-list" style="background:transparent;  align-items: center;margin:10px 0px -26px 0px">
                    <Rechner-hint-col style="margin:-22px 0 0 -2px ">
                        <template v-if="$store.state.rechnerConfig.rechnerInfo.name !='fahrrad'">
                            Hier können Sie zwischen den möglichen Tarifen wählen.
                            <br>Als Entscheidungshilfe können Sie einzelne Tarife unter „Zum Leistungsvergleich der Tarife“ miteinander vergleichen.
                        </template>
                    </Rechner-hint-col>
                    <template v-if="rabatt > 0">
                        <v-flex xs3>
                            Tarif
                        </v-flex>
                        <v-flex xs3>
                            Preis gemäß Zahlweise
                        </v-flex>
                        <v-flex xs2>
                            Jahrespreis
                        </v-flex>
                        <v-flex xs3>
                            ...
                        </v-flex>
                    </template>
                    <template v-else>
                        <v-flex xs4>
                            Tarif
                        </v-flex>
                        <v-flex xs4>
                            Preis gemäß Zahlweise
                        </v-flex>
                        <v-flex xs3>
                            Jahrespreis
                        </v-flex>
                    </template>




                </v-layout>

                <!--#########################################################################################################################-->
                <template v-if="$route.query.multitarif==1">
                    <v-layout v-for="(tarif, index) in $store.state.tarife"
                              :key="index"
                              class="radio-list"
                              row
                              style="  align-items: center;margin:8px 10px 8px 0px;line-height: 1.1em">
                        <v-flex class="myTarif-radios ">
                            <v-checkbox v-model="value.fieldValues.vertrag_tarifwahl"
                                        :label="tarif.tarif_name"
                                        :value="tarif.tarif_id"
                                        :rules="[() => ($v.value.fieldValues.vertrag_tarifwahl.$error ? 'Pflichtfeld' : true)]"
                                        :error-messages="$v.value.fieldValues.vertrag_tarifwahl.$error ? 'Pflichtfeld'  : []"
                                        :disabled="tarif.valid=='0'"
                                        v-if="hideDummy"
                            >
                            </v-checkbox>
                        </v-flex>
                        <template v-if="tarif.valid=='1'">
                            <v-flex xs3 class="myTarif-radios">
                                <b>X{{tarif.price_brutto_zahlweise | number_DB_currency_de}}€</b>
                            </v-flex>
                            <v-flex xs3 :class="{'myTarif-radios':true, zweiStellig:price_brutto_year<100 , dreiStellig:price_brutto_year>=100}">
                                <b>Y{{tarif.price_brutto_year | number_DB_currency_de}}€</b>
                            </v-flex>
                            <v-flex xs3 class="myTarif-radios" v-if="rabatt > 0">
                                Z(<i>{{tarif.price_netto_year | number_DB_currency_de}}€</i>)
                            </v-flex>
                            <v-flex xs3 class="myTarif-radios" v-if="rabatt > 0">
                                W(<i>{{tarif.price_netto_year_vorRab | number_DB_currency_de}}€</i>)
                            </v-flex>
                        </template>
                        <template v-else>
                            <v-flex xs8>
                                <i style="color:#919191">{{tarif.invalid_info}}</i>
                            </v-flex>
                        </template>
                    </v-layout>
                </template>
                <!--#########################################################################################################################-->
                <template v-else>
                    <v-radio-group
                            class="xxxxxx v-input--radio-group--row"
                            v-model="value.fieldValues.vertrag_tarifwahl"
                            :mandatory="false"
                            :rules="[() => ($v.value.fieldValues.vertrag_tarifwahl.$error ? 'Pflichtfeld' : true)]"
                            :error-messages="$v.value.fieldValues.vertrag_tarifwahl.$error ? 'Pflichtfeld' : []"
                            key="tarifRadioGroup"
                    >
                        <v-layout v-for="(tarif, index) in $store.state.tarife"
                                  :key="index"
                                  class="radio-list"
                                  row
                                  style="  align-items: center;">
                            <v-flex xs6 class="myTarif-radios">
                                <v-radio
                                        class="my_radio_input"
                                        :hint="tarif.tarif_id"
                                        :label="tarif.tarif_name"
                                        :value="tarif.tarif_id"
                                        :rules="[() => ( $v.value.fieldValues.vertrag_tarifwahl.$error ? 'Pflichtfeld': true )]"
                                        :error-messages="$v.value.fieldValues.vertrag_tarifwahl.$error ? 'Pflichtfeld'  : []"
                                        :disabled="tarif.valid=='0'"
                                ></v-radio>
                                <div class="tarif_subTitle">&nbsp;{{tarif.tarif_subName}}</div>
                            </v-flex>
                            <template v-if="tarif.valid=='1'">
                                <v-flex xs3 :class="{'myTarif-radios':true, zweiStellig_A:tarif.price_brutto_zahlweise<100 , dreiStellig_A:tarif.price_brutto_zahlweise>=100}">
                                    <b>{{tarif.price_brutto_zahlweise | number_DB_currency_de}}€</b>
                                </v-flex>
                                <v-flex xs3 :class="{'myTarif-radios':true, zweiStellig_B:tarif.price_brutto_year<100 , dreiStellig_B:tarif.price_brutto_year>=100}">
                                    <b>{{tarif.price_brutto_year | number_DB_currency_de}}€</b>
                                </v-flex>
                                <v-flex xs3 class="myTarif-radios" v-if="rabatt > 0">
                                    <i style="color:#787878">dank {{rabatt}}% Rabatt<br> <span style="color:#033c00;font-weight: bold;">{{tarif.price_brutto_year_vorRab - tarif.price_brutto_year | number_DB_currency_de}}€</span> gespart !</i>
                                </v-flex>
                            </template>
                            <template v-else>
                                <v-flex xs8>
                                    <i style="color:#919191">{{tarif.invalid_info}}</i>
                                </v-flex>
                            </template>
                        </v-layout>
                    </v-radio-group>
                    <!-- ¹²³⁴⁵⁶⁷⁸⁹ -->
                    <v-layout v-for="(footnote) in $store.state.tarifeFootnotes" style="border-bottom:solid 1px #ddd;margin:0 0 5px 0;font-size: 1em;" :key="footnote.letter">

                        <v-flex xs11 style="color: rgb(91, 91, 170);font-size: 0.85em;font-style: italic;">
                            <h4 v-if="footnote.heading>''" style="text-align: left;">{{footnote.letter}} &nbsp;{{footnote.heading}}:</h4>

                            <div style="margin:0 0 0 12px">
                                <span v-if="!(footnote.heading>'')" style="font-weight: bold;margin: 0 0px 0 -10px;">{{footnote.letter}}</span>
                                {{footnote.text}}
                            </div>
                        </v-flex>
                    </v-layout>


                    <v-layout v-if="Object.keys($store.state.tarifeFootnotes).length>0" style="border-top:solid 3px #ddd;margin:-6px 0 20px 0;font-size: 1em;">
                    </v-layout>
                </template>
                <!--#########################################################################################################################-->

                <v-layout row wrap fluid v-if="$store.state.rechnerConfig.rechnerInfo.name =='fahrrad'">
                    <v-flex xs10 lg5 style="">
                        Tarif-Informationen zum Ansehen und Herunterladen:
                    </v-flex>
                    <v-flex xs10 lg5 style="">
                        <i class="far fa-file-pdf" style="color:#cb0000;  font-size: 16px;"></i>
                        <a target="_blank" :href="pdf_path_bedingungen">
                            Produktinformationsblatt,
                            Pflichtinfo.,
                            Bedingungswerk
                        </a><br><br>
                    </v-flex>
                </v-layout>
                <v-layout>
                    <v-flex xs1 style="">
                        <v-icon medium class="mt-0 primary--text" floating>info</v-icon>
                    </v-flex>
                    <v-flex xs10 style="color: rgb(91, 91, 170);font-size: 0.9em;font-style: italic;">
                        Diese Leistungsbeschreibung ist lediglich eine Kurzübersicht.
                        Der rechtsverbindliche Umfang des Versicherungsschutzes geht <u>ausschließlich</u>
                        aus den Versicherungsbedingungen hervor.
                        <!-- <br>
                         Sie können diese Leistungsbeschreibung auch als pdf <a href="TEST">öffnen/herunterladen</a>
                         -->
                    </v-flex>
                </v-layout>
                <v-layout v-if="$store.state.leistungen[0]"
                          row
                          class="type_heading LeistRow Leistung_header"
                          :key="'leistRow0'">
                    <v-flex xs4 class="label"
                            :style="{flexBasis: ((7-$store.state.leistungen[0].tarife.length)*10)+'%', minWidth:'100px', maxWidth:'initial', flexGrow:0}">
                        Auszug aus den Leistungen
                    </v-flex>
                    <v-flex v-for="(leistung, colIndex) in $store.state.leistungen[0].tarife"
                            class="leistung_cell"
                            xs2
                            :style="{flexBasis: ((3+$store.state.leistungen[0].tarife.length)/$store.state.leistungen[0].tarife.length*10)+'%', minWidth:'100px', maxWidth:'initial', flexGrow:0}"
                            text-xs-center
                            :key="'leistung0-'+colIndex"
                            v-html="leistung.txt"
                    >
                    </v-flex>
                </v-layout>
                <div class="Leistung_container">
                    <v-layout row
                              v-for="(LeistRow, rowIndex) in $store.state.leistungen"
                              :class="{['type_'+LeistRow.typ] : true, 'LeistRow' : true }"
                              :key="'leistRow'+rowIndex">
                        <v-flex xs4 class="label"
                                v-if="LeistRow.typ!='heading'"
                                :style="{flexBasis: ((7-LeistRow.tarife.length)*10)+'%', minWidth:'100px', maxWidth:'initial', flexGrow:0}">
                            {{LeistRow.label}}
                        </v-flex>
                        <v-flex v-for="(leistung, colIndex) in LeistRow.tarife"
                                v-if="LeistRow.typ!='heading'"
                                class="leistung_cell"
                                :class="{'none':leistung.txt=='', 'neutral':LeistRow.typ=='neutral'}"
                                xs2
                                :style="{flexBasis: ((3+LeistRow.tarife.length)/LeistRow.tarife.length*10)+'%', minWidth:'100px', maxWidth:'initial', flexGrow:0}"
                                text-xs-center
                                :key="'leistung'+rowIndex+'-'+colIndex"
                                v-html="leistung.txt"
                        >

                        </v-flex>
                    </v-layout>
                </div>
                <!------------------------------------------------------------------------------------------------------------>

            </v-form>

        </template>
    </StepTemplate>
</template>
<!-- _____________________________________________________________________________________________________________________________________________________________ -->
<!-- ############################################################################################################################################################# -->
<script>

    import slideMixin from '../stepMixin'
    import _ from 'lodash'


    //import {mapState} from 'vuex'

    export default {
        //========================================================================================================
        data: function () {

            //fieldDefs wird in StepMixin mit den Werten aus der Datenbank belegt,
            //an dieser Stelle können diese Werte überschrieben werden.
            // Vue merged von alleine die Werte aus 'stepMixin' und denen aus 'fieldDefs_OVERRIDE'
            var fieldDefs_OVERRIDE = {}

            return {
                Tarife_loaded: false,
                Tarife_selectStates: {},
                fieldDefs: fieldDefs_OVERRIDE,
                hideDummy: true,

            }
        }, //========================================================================================================
        name: 'Step_Tarifwahl',
        label: 'Tarife',

        fieldKeys: [
            'vertrag_tarifwahl',

        ],
        //========================================================================================================
        mixins: [slideMixin],
        //===========================================================================================================
        computed: {
            //..................................................................................................
            pdf_path_bedingungen: function () {
                var tarife = this.$store.state.tarife;
                var tid = this.allSteps.Step_Tarifwahl.fieldValues.vertrag_tarifwahl;
                var tarif = _.find(tarife, {'tarif_id': tid});
                console.log("§ § § § § § § § § § § § § §")
                console.log(tarife, tid, tarif)
                if (tarif) {
                    var fileName = tarif.pdfs;
                    var filePathAndName = 'https://moat.nordline-assecuranz.de/bedingungen/' + fileName + '.pdf';
                } else {
                    filePathAndName = '[noch nicht möglich]';
                }
                return filePathAndName;
            }, //..................................................................................................
            rabatt: function () {
                var rabatt = 0;
                var first_tarif = Object.values(this.$store.state.tarife)[0]

                if (first_tarif) {
                    rabatt = first_tarif.rabatt_prozent;
                }

                return rabatt
            }, //..................................................................................................

        },     //===========================================================================================================
        components: {/* programmatically setted by step-mixin*/},
        //===========================================================================================================
        props: [/* programmatically setted by step-mixin*/],
        //===========================================================================================================
        watch: {

            isActive: {
                handler: function (newVal, oldVal) {
                    console.log("changed 'isActive' old -> current", oldVal, this.isActive)
                    console.log("<<<<<<<<< STEP Tarife changed 'isActive' >>>>>>>>>>>>")
                    if (this.isActive) {
                        this.loadTarife()
                    }
                },
                deep: true,
            },
            value: {
                handler: function (newVal, oldVal) {
                    console.log("~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~")
                    console.log("WATCHER fieldValues in ", this.$options.label)
                    var fV = this.value.fieldValues
                    var fVold = this.frmValuesOld
                    var earlyExit = true;
                    for (var key in fV) {
                        if (fV[key] !== fVold[key]) {
                            earlyExit = false
                            console.log("changed ", key, fVold[key], '->', fV[key])

                            console.log("XXXXX1 VALIDATE")
                            //var temp = this.validateRule
                            this.hideDummy = false
                            this.$forceUpdate()
                            this.$nextTick(function () {
                                this.hideDummy = true
                            })

                            /*
                                                                      setTimeout(() => {
                                                                        console.log("XXXXX2 VALIDATE")
                                                                        this.$forceUpdate()
                                                                        this.$v.value.fieldValues.vertrag_tarifwahl.$touch()
                                                                        //this.validateRule = [() => (this.$v.value.fieldValues.vertrag_tarifwahl.$error ? 'Pflichtfeld' : true)]
                                                                        this.$forceUpdate()
                                                                      }, 1000)
                                                        */
                        }
                    }
                    if (earlyExit === true) {
                        console.log("NO changes -> early EXIT")
                        return
                    }
                    this.frmValuesOld = _.assign({}, fV)
                },
                deep: true,

            }
        }, //===========================================================================================================
        methods: {
            loadTarife: function () {
                this.Tarife_loaded = false;

                var values = {};
                _.forEach(this.allSteps, (step, stepName) => {
                    if (stepName === 'Step_Tarifwahl') {
                        return
                    }
                    values = _.assign({}, step.fieldValues, values)


                })
                var rechnerName = this.$route.params.rechnerName === undefined ? '' : this.$route.params.rechnerName
                var vermittlerNr = this.$route.params.vermittlerNr === undefined ? '' : this.$route.params.vermittlerNr
                var tarif_gruppe = 'tarif_' + (typeof this.$route.query.tarifgruppe === "undefined" ? 'n' : this.$route.query.tarifgruppe)
                var tarif_filter = (typeof this.$route.query.tariffilter === "undefined" ? 'standard' : this.$route.query.tariffilter)

                this.$store.dispatch(
                    'sendApiRequest',
                    {
                        sender: 'RechnerTemplate->created',
                        command: 'getTarife',
                        args: {
                            url_param_rechner: rechnerName,
                            url_param_vermittler: vermittlerNr,
                            url_param_rechner: this.$route.params.rechnerName,
                            url_param_tarifgruppe: tarif_gruppe,
                            url_param_tariffilter: tarif_filter,
                            values: values
                        },
                        onSuccess: (response) => {

                            //Tarife-keys nach Tarfife-Id-Reihenfolge sortieren
                            var sorted_tarife_keys = Object.keys(response.data.tarife).sort(function (a, b) {
                                return response.data.tarife[a].tarif_id - response.data.tarife[b].tarif_id
                            })
                            //Tarife in ein neues Objekt in der sortierten Reihenfolge schreiben:
                            var sorted_tarife_Obj = {}
                            for (var index in sorted_tarife_keys) {
                                var key = sorted_tarife_keys[index]
                                var val = response.data.tarife[key]
                                //console.log("tarif-test 3", index, key, val)
                                sorted_tarife_Obj[key] = val
                            }
                            //console.log("tarif-test 4", sorted_tarife_Obj)


                            this.$store.commit('set_tarife', {data: sorted_tarife_Obj});
                            this.$store.commit('set_leistungen', {data: response.data.leistungen});
                            this.$store.commit('set_tarifeFootnotes', {data: response.data.footnotes});

                            //Tarifwahl restten, da sich Tarif-Angebot geändert haben könnte (bzw. invalide Tarife dabei sind)
                            this.value.fieldValues.vertrag_tarifwahl = [];


                            //Wenn die Abfrage nur einen Tarif liefert, dann diesen bestimmen ...
                            if (_.size(response.data.tarife) === 1) {
                                var tarif = _.sample(response.data.tarife);
                                var id = tarif.tarif_id;
                                // ...und mit seiner ID im Formular den ersten Radio-Button aktivieren
                                // wenn Tarif valide ist
                                if (tarif.valid === "1") {
                                    this.value.fieldValues.vertrag_tarifwahl = id;
                                }

                            }

                            this.Tarife_loaded = true;

                        }
                    }
                );
            },
        },
        // HOOKS:
        /* programmatically setted by step-mixin*/
        mounted: function () {

        }//===========================================================================================================
    }
</script>
<!-- ############################################################################################################################################################# -->
<!-- ¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯ -->
<style>
    .my_radio_form .radio-list .input-group__details {
        position: absolute;
        left: 33px;
        top: 17px;
    }

    .my_radio_form .radio-list {
        margin: 0px 10px 0px 0px;
        padding: 8px 0 8px 0;
        line-height: 1.1em
    }

    .radio-list:nth-child(odd) {
        background-color: #d6d3e854;
    }

    .radio-list:nth-child(even) {
        background-color: #d6d3e81a;
    }

    .checkbox .input-group__details {
        position: absolute;
        left: 33px;
        top: 34px;
    }

    .myTarif-radios {
        font-size: 14px;
    }


    .myTarif-radios .v-radio.my_radio_input {
        margin-bottom: 0;
    }

    .radio-list .input-group--error label {
        color: #f44336 !important;
    }

    .radio-list .v-input--radio-group .v-radio {
        margin-bottom: 0;
    }

    /*-------------------------------------------------------------------*/
    .LeistRow .flex {
        border-top: 1px solid #aaa;
    }

    .LeistRow:nth-child(even) {

    }

    .LeistRow.type_heading {
        font-weight: bold;
    }

    .LeistRow.type_neutral {
        font-weight: bold;
        background: #eee;
    }
    .LeistRow.type_sub .flex {
        border-top: 1px dotted #ccc;
    }

    .LeistRow.type_sub .label {
        padding: 0 0 0 30px;
        font-size: 0.85rem;
    }

    .LeistRow.type_sub .label:before {
        content: "-";
        margin: 0 0 0 -11px;
        font-weight: bold;
        font-size: 1.1rem;
    }

    .LeistRow .label {
        padding: 4px 4px;
        word-break: break-word;

    }

    .LeistRow .leistung_cell {
        border-left: 1px solid #aaa;
        border-right: 1px solid #aaa;
        background: #ebfaeb;
        padding: 4px 4px;
        font-size: 0.8rem;
    }

    .leistung_cell.none {
        background: #ebfaeb;
        /* background: #ffe7e6; */
    }

    .leistung_cell.neutral {
        background: #eee;
    }

    .LeistRow.type_heading .flex {
        background: #eee;
        border-bottom: solid 1px #333;
    }

    .Leistung_header {
        padding: 0 18px 0 0;
        width: calc(100% - 32px);
    }

    .Leistung_container {
        overflow-y: scroll;
        overflow-x: hidden;
        height: 430px;
        margin: 0 -30px 20px -12px;
        padding: 0 13px 0 12px;
        width: 99%;
    }

    .my_radio_form .theme--light.v-label {
        color: #000000;
    }

    .my_radio_form .tarif_subTitle {
        margin: -10px 0 -6px 23px;
        font-size: 0.9em;
        color: #636079;
    }

    .my_radio_form .zweiStellig_A {
        padding: 0 0 0 0.65em;
    }

    .my_radio_form .dreiStellig_A {
        padding: 0 0 0 0;
    }

    .my_radio_form .zweiStellig_B {
        padding: 0 0 0 2.7em;
    }

    .my_radio_form .dreiStellig_B {
        padding: 0 0 0 2em;
    }
</style>
